import { useQuery } from 'react-query';

import { getTrapDetail } from 'api/traps/Trap/getTrapDetail';

export const useGetTrapDetail = (slug: string, type: string) => {
  const { data, refetch, isLoading, isRefetching } = useQuery('GetTrapDetail', () => getTrapDetail(slug, type), {
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading, isRefetching };
};

export default useGetTrapDetail;
